import {FileAspectSubType} from '../constants';
import {FileAspectSubTypeLabel} from '../locales';

export const getFileAspectSubTypeLabel = (option: FileAspectSubType) =>
	FileAspectSubTypeLabel[option];

export default getFileAspectSubTypeLabel;
